import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Grid } from 'semantic-ui-react';

import {
  InputField,
  DatePickerField,
  SelectField,
} from 'Common/SemanticWrapper';
import { ExportTotalsFieldEnum } from 'Common/FieldEnum';

class Chartwells extends Component {
  render() {
    const { breakfastOptions, lunchOptions } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={2}>
            <Field
              component={InputField}
              label="Unit Number"
              name={ExportTotalsFieldEnum.UnitNumber}
              hideEmptyError={true}
              showOnlyTouchedError={true}
              maxLength={5}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={6}>
            <Field
              component={SelectField}
              label="Breakfast Item"
              name={ExportTotalsFieldEnum.BreakfastItemId}
              options={breakfastOptions}
            />
            <Field
              component={SelectField}
              label="Lunch Item"
              name={ExportTotalsFieldEnum.LunchItemId}
              options={lunchOptions}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3}>
            <Field
              component={DatePickerField}
              label="From"
              name={ExportTotalsFieldEnum.FromDate}
              fluid
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <Field
              component={DatePickerField}
              label="To"
              name={ExportTotalsFieldEnum.ToDate}
              fluid
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export { Chartwells };



// WEBPACK FOOTER //
// ./src/pages/exporttotals/components/Chartwells.js